export const i18nBusiness = {
  model_type: {
    pdm: 'pdm',
    condition_based: 'Condition based',
    regression: 'Regression',
  },
  model_view: {
    title: 'Model View',
    high: 'High',
    medium: 'Medium',
    good: 'Good',
  },
  alarm: {
    status: {
      anomaly_detected: 'Anomaly detected',
      risk_of_failure: 'Risk of failure',
      under_investigation: 'Under investigation',
      closed: 'Closed',
    },
    classification: {
      need_intervention: 'Intervention needed',
      no_action_needed: 'No action needed',
      inappropriate_limits: 'Inappropriate thresholds',
      instrumentation_problem: 'Instrumentation problem',
      others: 'Other',
      real_alarm: 'Real alarm',
      false_alarm: 'False alarm',
      useful: 'Useful',
      not_useful: 'Not useful',
    },
    action: {
      none: 'None',
      cleaning: 'Cleaning',
      repair: 'Repair',
      machine_restart: 'Machine restart',
      parameters_adjustments: 'Parameters adjustments',
      parts_replacement: 'Parts replacement',
      others: 'Others',
    },
    reason: {
      process_instability: 'Process instability',
      resumption_production: 'Resumption production',
      instrumentation_problem: 'Instrument error',
      process_change: 'Process change',
      tests_in_progress: 'Tests in progress',
      not_sure: 'Not sure',
      insufficient_time: 'Insufficient time',
      action_not_effective: 'Not effective action',
      inappropriate_limits: 'Inappropriate limits',
      uncalibrated_model: 'Uncalibrated model',
      others: 'Others',
    },
  },
  sensor: {
    status: {
      active: { active: 'active', active_one: 'active', active_other: 'active' },
      delayed: { delayed: 'delayed', delayed_one: 'delayed', delayed_other: 'delayed' },
      no_data: { no_data: 'no data', no_data_one: 'no data', no_data_other: 'no data' },
      offline: { offline: 'offline', offline_one: 'offline', offline_other: 'offline' },
    },
  },
  pump_curve: {
    kpi: {
      power_calculated: 'Power calculated',
      power_expected: 'Power exp',
      density: 'Density',
      efficiency: 'Efficiency',
      efficiency_expected: 'Efficiency exp',
      rotation: 'Rotation',
      flow_rate: 'Flow rate',
      pressure_discharge: 'Pressure dis',
      box_level: 'Box level',
      npsha: 'NPSHa',
      npshr: 'NPSHr',
    },
  },
};
